var exports = {
  "iE": "xaf9ae18d--f82e1b--wrapper",
  "kL": "xaf9ae18d--f82e1b--container",
  "mb": "xaf9ae18d--f82e1b--redesign",
  "pF": "xaf9ae18d--f82e1b--indent--extra-large",
  "H4": "xaf9ae18d--f82e1b--placement--left",
  "Y$": "xaf9ae18d--f82e1b--placement--right",
  "RG": "xaf9ae18d--f82e1b--placement--top",
  "s4": "xaf9ae18d--f82e1b--placement--top-right",
  "n3": "xaf9ae18d--f82e1b--placement--top-left",
  "FG": "xaf9ae18d--f82e1b--placement--bottom",
  "aD": "xaf9ae18d--f82e1b--placement--bottom-right",
  "nD": "xaf9ae18d--f82e1b--placement--bottom-left",
  "tZ": "xaf9ae18d--f82e1b--side-indent",
};

module.exports = exports;
